<template>
  <div v-if="menus" id="footer-menu">
    <ul v-if="menus.footerMain">
      <li v-for="menuItem in menus.footerMain.items" :key="menuItem.uid">
        <a
          class="menu-item"
          @click.prevent="getStoryblokLink(menuItem.link, menuItem.blank)"
          :href="menuItem.cached_url"
          v-html="menuItem.title"
        ></a>
      </li>
    </ul>
    <a class="advg-link" href="http://www.adventuregroup.fr/" target="_blank">
      <img class="advg" src="../../../public/img/advg.png">
    </a>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  computed: {
    menus() {
      return this.$store.getters.menus;
    }
  }
};
</script>

<style lang="scss">
#footer-menu {
  > ul {
    display: flex;
    align-items: center;
    justify-content: left;
    background-color: $primary;
    > li {
      > a {
        padding: 25px 15px;
        display: block;
        text-decoration: none;
        color: #fff;
        font-size: 15px;
        &:hover:not(.advg-link) {
          background-color: #fff;
          color: $primary-D2;
          cursor: pointer;
        }
      }
      .advg {
        max-width: 150px;
      }
    }
  }
  .advg-link {
    position: absolute;
    z-index: 33;
    right: 0px;
    bottom: 0;

    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .advg {
      max-width: 150px;
    }
  }
}

@media screen and (max-width: $desktop) {
  .advg-link {
    position: absolute;
    z-index: 33;
    right: 0px;
    bottom: 0;

    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .advg {
      max-width: 150px;
    }
  }
}

@media screen and (max-width: 625px) {
  #footer-menu {
    > ul {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
